import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { Tooltip } from '@material-ui/core';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import MLIcon from '../../../../components/MLIcon';
import MLToolLaunchLink from '../../../components/MLToolLaunchLink';
import s from '../overviewWidget.module.css';
import { WRITING_TYPE, REPORT_KEYS } from '../../../actions/constants';
import { refreshReport as refreshReportAction } from '../../../actions/reports';

class StudentRevisionPlansComponent extends Component {
  static propTypes = {
    reports: PropTypes.object,
    refreshReport: PropTypes.func,
    loading: PropTypes.bool,
    getLaunchUrl: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      showingAll: false,
    };
    this.handleClickShowAll = this.handleClickShowAll.bind(this);
  }

  async componentDidMount() {
    this.props.refreshReport(REPORT_KEYS.revisionPlanWidget);
  }

  handleClickShowAll() {
    const { showingAll } = this.state;
    this.setState({
      showingAll: !showingAll,
    });
  }

  shouldDisplayWidget() {
    const { revisionPlan } = this.props.reports.revisionPlanWidget;
    return (
      !_.isEmpty(revisionPlan) &&
      !_.isNull(revisionPlan.nextDraftDueDate) &&
      revisionPlan.previousDraftHasInstructorFeedback &&
      !_.isNull(revisionPlan.previousDraftStudentDraftReviewId)
    );
  }

  renderNullState(message, writingType, revisionPlan) {
    return (
      <div className={s.nullState}>
        <div className={s.descriptionTask}>
          <div className={s.titleTask}>{message}</div>
          <MLToolLaunchLink
            data={{
              ...revisionPlan,
              type: writingType,
              id: revisionPlan.assignment.id,
              name: revisionPlan.draftName,
              activity_id: revisionPlan.activityId,
              course_id: this.props.reports.courseAbstract.id,
              productModelId: this.props.reports.courseAbstract.productModelId,
              short_id: this.props.reports.courseAbstract.shortId,
              tool: revisionPlan.assignment && revisionPlan.assignment.tool,
              studentDraftReviewId: revisionPlan.previousDraftStudentDraftReviewId,
            }}
            className={s.linkText}
            linkLabel="View feedback and develop your revision plan."
            getLaunchUrl={this.props.getLaunchUrl}
            testId="view-feedback-and-develop-your-revision-plan"
          />
        </div>
      </div>
    );
  }

  render() {
    const { showingAll } = this.state;
    const { loading } = this.props;
    const revisionPlan = this.props.reports.revisionPlanWidget
      ? this.props.reports.revisionPlanWidget.revisionPlan
      : null;
    const msgNullStateNotAssigned = 'Your instructor has left you feedback.';
    const msgNullStateNotStarted =
      'Your instructor has left feedback and assigned you a revision plan.';
    const writingType = WRITING_TYPE.REVIEW_FEEDBACK;
    let msgNullState;
    if (!revisionPlan || (!this.shouldDisplayWidget() && !loading)) return null;
    const nullState = revisionPlan && _.isEmpty(revisionPlan.revisionPlanItems);

    if (nullState) {
      msgNullState = msgNullStateNotStarted;
      if (
        !revisionPlan.revisionPlanRequired &&
        !_.isNull(revisionPlan.studentDraftId)
      ) {
        msgNullState = msgNullStateNotAssigned;
      }
    }
    const nextDraftDays =
      revisionPlan &&
      revisionPlan.nextDraftDueDate &&
      moment(revisionPlan.nextDraftDueDate).diff(moment(), 'days');
    const getHeader = (hideInfo = true) => (
      <div className={s.header}>
        <div className={s.titleContainer}>
          <div
            className={[s.title, nullState ? s.revisionNullState : ''].join(
              ' '
            )}
          >
            Revision Progress
          </div>
          {!hideInfo && (
            <div className={s.incompleteTasks}>{`${
              revisionPlan.incompleteRevisionCount
            }/${revisionPlan.totalRevisionCount} task${
              revisionPlan.totalRevisionCount !== 1 ? 's are' : ' is'
            } incomplete`}</div>
          )}
        </div>
        {!hideInfo && (
          <div className={s.draftContainer}>
            <Tooltip title={`Argument Essay: ${revisionPlan.draftName}`} placement="bottom">
              <span>
                <MLToolLaunchLink
                  data={{
                    ...revisionPlan,
                    type: WRITING_TYPE.REVIEW_FEEDBACK,
                    id: revisionPlan.assignment.id,
                    name: revisionPlan.draftName,
                    activity_id: revisionPlan.activityId,
                    course_id: this.props.reports.courseAbstract.id,
                    productModelId: this.props.reports.courseAbstract
                      .productModelId,
                    short_id: this.props.reports.courseAbstract.shortId,
                    tool:
                      revisionPlan.assignment && revisionPlan.assignment.tool,
                    studentDraftReviewId: revisionPlan.previousDraftStudentDraftReviewId,
                  }}
                  className={s.titleDraft}
                  linkLabel={`Argument Essay: ${revisionPlan.draftName}`}
                  getLaunchUrl={this.props.getLaunchUrl}
                />
              </span>
            </Tooltip>

            <div className={s.nextDraft}>{`Next draft due in ${nextDraftDays} ${
              nextDraftDays !== 1 ? 'days' : 'day'
            }`}</div>
          </div>
        )}
      </div>
    );
    const numberItemsToDisplay = 2;
    const getListIncompleteTasks = (tasks) =>
      _.isEmpty(tasks) ? null : (
        <div>
          <ul className={s.listTasks}>
            {tasks.map((task, index) => (
              <li className={s.taskItem} key={index}>
                {!task.isCompleted ? (
                  <MLIcon
                    type="info"
                    className={[s.iconInfo, s.icon].join(' ')}
                  />
                ) : (
                  <MLIcon
                    type="circle_check_outline"
                    className={[s.iconComplete, s.icon].join(' ')}
                  />
                )}
                <div className={s.descriptionTask}>
                  <Tooltip title={task.description} placement="bottom">
                    <div className={s.titleTask}>{task.description}</div>
                  </Tooltip>
                  {!task.isCompleted ? (
                    <MLToolLaunchLink
                      data={{
                        ...revisionPlan,
                        type: WRITING_TYPE.REVISION_PLAN,
                        id: revisionPlan.assignment.id,
                        name: revisionPlan.draftName,
                        activity_id: revisionPlan.activityId,
                        course_id: this.props.reports.courseAbstract.id,
                        productModelId: this.props.reports.courseAbstract
                          .productModelId,
                        short_id: this.props.reports.courseAbstract.shortId,
                        tool:
                          revisionPlan.assignment &&
                          revisionPlan.assignment.tool,
                        studentDraftReviewId: revisionPlan.previousDraftStudentDraftReviewId,
                      }}
                      className={s.viewAndComplete}
                      linkLabel="View and complete now"
                      testId="revision-progress-view-and-complete-now"
                      getLaunchUrl={this.props.getLaunchUrl}
                    />
                  ) : (
                    <div className={s.complete}>Complete</div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      );
    const showAllBtn = () => {
      const arrow = (
        <MLIcon
          type={showingAll ? 'chevron_up' : 'chevron_down'}
          className={s.collapse}
        />
      );
      const cloned = React.cloneElement(arrow, { tabIndex: null }, null);
      const dataTestId = showingAll
        ? 'revision-progress-show-less'
        : 'revision-progress-show-all';
      return (
        <button
          className={s.showAllBtn}
          onClick={this.handleClickShowAll}
          data-test-id={dataTestId}
        >
          <div className={s.textShowAll}>
            {showingAll ? 'Show Less' : 'Show All'}
          </div>
          {cloned}
        </button>
      );
    };
    const hideInfo = nullState || loading;
    const filteredTasks =
      revisionPlan &&
      revisionPlan.revisionPlanItems &&
      revisionPlan.revisionPlanItems.filter(
        (task, index) =>
          showingAll ||
          (!showingAll && !task.isCompleted && index < numberItemsToDisplay)
      );
    const showButton =
      revisionPlan &&
      filteredTasks.length &&
      filteredTasks.length > 0 &&
      revisionPlan.revisionPlanItems.length > numberItemsToDisplay;
    return (
      <div className={s.revisionComponent}>
        {getHeader(hideInfo)}
        <hr className={s.dividerTask} />
        {loading && <Spinner className={s.spinner} />}
        {!loading && !nullState && (
          <div>
            {getListIncompleteTasks(filteredTasks)}
            {showButton && <hr className={s.dividerTask} />}
            {showButton && showAllBtn()}
          </div>
        )}
        {!loading &&
          nullState &&
          this.renderNullState(msgNullState, writingType, revisionPlan)}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ refreshReport: refreshReportAction }, dispatch);

const mapStateToProps = (state) => ({
  reports: state.reports,
  loading:
    !state.reports.courseAbstract ||
    state.reports.courseAbstract.loading ||
    !state.reports.revisionPlanWidget ||
    state.reports.revisionPlanWidget.loading,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentRevisionPlansComponent);
